import { pageTypes } from "../../global/constants/pageTypes";
import { updateObjectWithDeltaIn } from "../../global/utility/Utils";
import { types } from "../actions";

const initialState = {
    activeSession: {
        accountId: "",
        sessionToken: "",
        userName: ""
    },
    selectedLeftNav: pageTypes.DASHBOARD
};

const sessionReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_ACTIVE_SESSION: {
            return {
                ...state,
                activeSession: action.payload
            };
        }
        case types.UPDATE_ACTIVE_SESSION_DELTA: {
            return {
                ...state,
                activeSession: {activeSession: updateObjectWithDeltaIn(state.activeSession.activeSession, action.payload)}
            };
        }
        case types.UPDATE_SELECTED_LEFT_NAV: {
            return {
                ...state,
                selectedLeftNav: action.payload
            }
        }
        default:
            return state;
    }
};
export default sessionReducer;